module.exports = __webpack_public_path__ + "img/Bioland_Logo_2012.de74494d.svg";